<div class="tab-content">
  @if (maintenanceManagementEnabled) {
  <div class="form-group relative" [formGroup]="form">
    <!-- CONTRAT DE MAINTENANCE -->
    <div class="form-field relative" [class.missing-data]="isFieldMissing('maintenance_contract')">
      <label for="maintenance_contract">{{ "asset_form_drawer.maintenance.contract" | translate }}</label>
        <nb-select
          id="maintenance_contract"
          formControlName="maintenance_contract"
          fullWidth
          placeholder="{{ 'asset_form_drawer.placeholders.select' | translate }}"
        >
          <nb-option value="">-</nb-option>
          <nb-option value="true">{{ "asset_form_drawer.options.yes" | translate }}</nb-option>
          <nb-option value="false">{{ "asset_form_drawer.options.no" | translate }}</nb-option>
        </nb-select>
        @if (showMaintenanceContractIndicator) {
        <fa-icon 
          [icon]="['fas', 'bell']" 
          class="alert-icon" 
          style="position: absolute; top: 20px; right: 54px; cursor: default; border: none; pointer-events: none;">
        </fa-icon>
        }
    </div>

    <!-- NIVEAU DE MAINTENANCE -->
    <div class="form-field" [class.missing-data]="isFieldMissing('maintenance_level')">
      <label for="maintenance_level">{{ "asset_form_drawer.maintenance.level" | translate }}</label>
      <nb-select
        id="maintenance_level"
        formControlName="maintenance_level"
        fullWidth
        placeholder="-"
      >
        <nb-option value="">-</nb-option>
        <nb-option value="1">{{ "asset_form_drawer.options.level_1" | translate }}</nb-option>
        <nb-option value="2">{{ "asset_form_drawer.options.level_2" | translate }}</nb-option>
        <nb-option value="3">{{ "asset_form_drawer.options.level_3" | translate }}</nb-option>
        <nb-option value="4">{{ "asset_form_drawer.options.level_4" | translate }}</nb-option>
        <nb-option value="5">{{ "asset_form_drawer.options.level_5" | translate }}</nb-option>
      </nb-select>
    </div>

    <!-- NOM DE LA SOCIÉTÉ DE MAINTENANCE -->
    <div class="form-field autocomplete-container" style="flex: 2;" [class.missing-data]="isFieldMissing('maintenance_company')">
      <label for="maintenance_company">{{ "asset_form_drawer.maintenance.company_name" | translate }}</label>
      <input 
        nbInput 
        id="maintenance_company" 
        type="text" 
        formControlName="maintenance_company" 
        fullWidth 
        maxlength="200"
        placeholder="-"
        (input)="onCompanyInputChange($event.target.value)"
        (focus)="onCompanyInputFocus($event.target.value)"
        (blur)="onCompanyInputBlur()"
      />
      @if (filteredCompanies.length > 0) {
        <div class="autocomplete-dropdown">
          @for (company of filteredCompanies; track company) {
            <div 
              class="autocomplete-item" 
              (click)="selectCompany(company)"
            >
              {{ company }}
            </div>
          }
        </div>
      }
    </div>

    <!-- DATE DE FIN DU CONTRAT DE MAINTENANCE -->
    <div class="form-field pb-2" [class.missing-data]="isFieldMissing('maintenance_contract_end_date')">
      <label for="maintenance_contract_end_date">
        {{ "asset_form_drawer.maintenance.contract_end_date" | translate }}
      </label>
      <div style="display: flex; align-items: center; gap: 8px; justify-content: space-between">
        <div class="datepicker-field">
          <input
              nbInput
              class="date-input"
              id="maintenance_contract_end_date"
              readonly
              [nbDatepicker]="maintenanceContractEndDatePicker"
              [value]="formatMonthYear(form.get('maintenance_contract_end_date')?.value)"
              (click)="!maintenanceContractEndDatePicker.isShown && maintenanceContractEndDatePicker.show()"
            />
          <button type="button" class="datepicker-toggle" (click)="$event.preventDefault(); $event.stopPropagation(); maintenanceContractEndDatePicker.isShown ? maintenanceContractEndDatePicker.hide() : maintenanceContractEndDatePicker.show()">
            <fa-icon [icon]="['fal', 'calendar']"></fa-icon>
          </button>
          <nb-datepicker
            #maintenanceContractEndDatePicker
            startView="year"
            [date]="toDateValue(form.get('maintenance_contract_end_date')?.value)"
            [visibleDate]="toDateValue(form.get('maintenance_contract_end_date')?.value) || defaultDatepickerDate()"
            (dateChange)="onDatepickerMonthChange($event, 'maintenance_contract_end_date')"
          ></nb-datepicker>
        </div>
        @if (!isColorWhite(getMaintenanceContractDeadlineColor())) {
        <fa-icon 
          [icon]="['fas', 'bell']" 
          class="alert-icon" 
          style="cursor: default; border: none; pointer-events: none; transform: translateX(-44px) translateY(-8px)">
        </fa-icon>
        }
      </div>
    </div>

    <!-- RESPONSABLE DE LA CHARGE DE LA MAINTENANCE -->
    <div class="form-field" [class.missing-data]="isFieldMissing('maintenance_responsible')">
      <label for="maintenance_responsible">
        {{ "asset_form_drawer.maintenance.responsible" | translate }}
      </label>
      <nb-select
        id="maintenance_responsible"
        formControlName="maintenance_responsible"
        fullWidth
        placeholder="{{ 'asset_form_drawer.placeholders.select_responsible' | translate }}"
      >
        <nb-option value="">-</nb-option>
        <nb-option value="occupant">{{ "asset_form_drawer.options.occupant" | translate }}</nb-option>
        <nb-option value="owner">{{ "asset_form_drawer.options.owner" | translate }}</nb-option>
        <nb-option value="other">{{ "asset_form_drawer.options.other" | translate }}</nb-option>
      </nb-select>
    </div>

    <!-- FRÉQUENCE CONTRÔLE CONSTRUCTEUR -->
    <div class="form-field" [class.missing-data]="isFieldMissing('manufacturer_control_frequency')">
      <label for="manufacturer_control_frequency">
        {{ "asset_form_drawer.maintenance.manufacturer_frequency" | translate }}
      </label>
      <nb-select
        id="manufacturer_control_frequency"
        formControlName="manufacturer_control_frequency"
        fullWidth
        placeholder="{{ 'asset_form_drawer.placeholders.select_frequency' | translate }}"
      >
        <nb-option value="">-</nb-option>
        <nb-option value="1 time per year">
          {{ "asset_form_drawer.options.once_per_year" | translate }}
        </nb-option>
        <nb-option value="1 time every 2 years">
          {{ "asset_form_drawer.options.once_every_2_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 3 years">
          {{ "asset_form_drawer.options.once_every_3_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 5 years">
          {{ "asset_form_drawer.options.once_every_5_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 10 years">
          {{ "asset_form_drawer.options.once_every_10_years" | translate }}
        </nb-option>
        <nb-option value="other">{{ "asset_form_drawer.options.other" | translate }}</nb-option>
      </nb-select>
    </div>

    <!-- DATE DERNIER CONTRÔLE MAINTENEUR -->
    <div class="form-field pb-2" [class.missing-data]="isFieldMissing('last_maintainer_control_date')">
      <label for="last_maintainer_control_date">
        {{ "asset_form_drawer.maintenance.last_control_date" | translate }}
      </label>
      <div style="display: flex; align-items: center; gap: 8px; justify-content: space-between">
        <div class="datepicker-field">
          <input
            nbInput
            class="date-input"
            id="last_maintainer_control_date"
            readonly
            [nbDatepicker]="lastMaintainerControlDatePicker"
            [value]="formatMonthYear(form.get('last_maintainer_control_date')?.value)"
            (click)="!lastMaintainerControlDatePicker.isShown && lastMaintainerControlDatePicker.show()"
          />
          <button type="button" class="datepicker-toggle" (click)="$event.preventDefault(); $event.stopPropagation(); lastMaintainerControlDatePicker.isShown ? lastMaintainerControlDatePicker.hide() : lastMaintainerControlDatePicker.show()">
            <fa-icon [icon]="['fal', 'calendar']"></fa-icon>
          </button>
          <nb-datepicker
            #lastMaintainerControlDatePicker
            startView="year"
            [date]="toDateValue(form.get('last_maintainer_control_date')?.value)"
            [visibleDate]="toDateValue(form.get('last_maintainer_control_date')?.value) || defaultDatepickerDate()"
            (dateChange)="onDatepickerMonthChange($event, 'last_maintainer_control_date')"
          ></nb-datepicker>
        </div>
        @if (!isColorWhite(getMaintenanceLastControlDateColor())) {
        <fa-icon 
          [icon]="['fas', 'bell']" 
          class="alert-icon" 
          style="cursor: default; border: none; pointer-events: none; transform: translateX(-44px) translateY(-8px)">
        </fa-icon>
        }
      </div>
    </div>

    <!-- COMMENTAIRE MAINTENANCE -->
    <div class="form-field">
      <label for="maintenance_comment">{{ "asset_form_drawer.maintenance.comment" | translate }}</label>
      <textarea
        nbInput
        id="maintenance_comment"
        formControlName="maintenance_comment"
        fullWidth
        rows="4"
        maxlength="512"
        placeholder="-"
      ></textarea>
    </div>
  </div>
  }
</div>
